"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RelatedStandardClient = void 0;
const sdk_contants_1 = require("../../constants/sdk.contants");
const serializers_1 = require("../serializers");
const retryable_1 = require("./retryable");
class RelatedStandardClient {
    static newInstance(options, retryOptions) {
        return new RelatedStandardClient(retryable_1.RetryableHttpClient.newInstance(options, retryOptions), new serializers_1.RelatedStandardSerializer());
    }
    constructor(client, relatedStandardSerializer) {
        this.client = client;
        this.relatedStandardSerializer = relatedStandardSerializer;
    }
    async findByGlobalId(standardItemGlobalIds, standardSetGlobalIds, headers) {
        const params = {
            standardItemGlobalId: standardItemGlobalIds,
            standardSetGlobalId: standardSetGlobalIds,
        };
        const response = await this.client.get(`${sdk_contants_1.ENGINE_API_PREFIX}/relatedStandards.findByGlobalId`, {
            headers,
            params,
        });
        return response.body.data.map((relatedStandard) => this.relatedStandardSerializer.serializeOne(relatedStandard));
    }
    async findByGlobalIdPost(standardItemGlobalIds, standardSetGlobalIds, headers) {
        const body = {
            standardItemGlobalId: standardItemGlobalIds,
            standardSetGlobalId: standardSetGlobalIds,
        };
        const response = await this.client.post(`${sdk_contants_1.ENGINE_API_PREFIX}/relatedStandards.findByGlobalId`, body, {
            headers,
        });
        return response.body.data.map((relatedStandard) => this.relatedStandardSerializer.serializeOne(relatedStandard));
    }
}
exports.RelatedStandardClient = RelatedStandardClient;
//# sourceMappingURL=related-standard.client.js.map